import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import Login from '../../components/Auth/Login';
import SignUp from '../../components/Auth/SignUp';
import ResetPassword from '../../components/Auth/RessetPassword';
import './AuthPage.css';
import Logo from './../../assets/logos/LogoColour.svg';

const AuthPage: React.FC = () => {
  const [view, setView] = React.useState<"login" | "signup" | "resetPassword">("login");
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  // Redirect to the home page if the user is already logged in
  useEffect(() => {
    if (!loading && user) {
      navigate('/'); // Redirect to home page
    }
  }, [user, loading, navigate]);

  return (
    <div className="auth-page">
      <div className="auth-image" />
      <div className="auth-form">
        <img src={Logo} alt="Logo" className="login-logo" />
        {view === "login" && <Login onSwitch={() => setView("signup")} onReset={() => setView("resetPassword")} />}
        {view === "signup" && <SignUp onSwitch={() => setView("login")} />}
        {view === "resetPassword" && <ResetPassword onSwitch={() => setView("login")} />}
      </div>
    </div>
  );
};

export default AuthPage;
